import { reducerWithInitialState } from 'typescript-fsa-reducers';
import { SearchBranch } from '../../../external/AggregationApi';
import { actions } from '../../modules/Actions';

export const initialSearchBranchResultState: { [key: string]: SearchBranch } = {};

export const searchBranchResultReducer = reducerWithInitialState(initialSearchBranchResultState).case(
  actions.updateSearchBranch.result,
  (state: { [key: string]: SearchBranch }, payload: { [key: string]: SearchBranch }) => {
    return {
      ...state,
      ...payload,
    };
  }
);
